function initFlickity($gallery) {
    'use strict';


    if ( $gallery.length ) {

        const $indexElement = $($gallery).find('.slide-index');

		$indexElement.text(1);

		const $slider = $($gallery).find('#slider');

		const changeIndex = (index) => {
			$indexElement.text(index + 1);
		};

        $slider.flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            on: {
                change: (index) => {
					changeIndex(index);
                }
            }
        });


		const $sliderData = $slider.data('flickity');

        $($gallery).find('.slider-previous').on('click', function () {
			$slider.flickity('previous', true);
			changeIndex($sliderData.selectedIndex);
        });

        $($gallery).find('.slider-next').on('click', function () {
            $slider.flickity('next', true);
			changeIndex($sliderData.selectedIndex);
        });

    }

}

export default initFlickity;
